import { defineComponent as _defineComponent } from 'vue'
import { useRoute } from "vue-router";
import { onMounted, ref } from 'vue'
import { storeToRefs } from "pinia";
import { usePiniaState } from "@/store/userPinia";

import { ballNewsDetail, ballNewsCommentList, ballNewsZan, ballNewsComment } from "@/api/php/home"
import router from "@/router";
import sendBtn from "@/assets/images/sendBtn.png";
import { Toast } from "vant";

import { serverConfigPiniaState } from "@/store/serverConfig";
import { cheackQuery, ToBack, toLocationBrowser, nativeToLogin } from "@/uitls/native";
import { useI18n } from 'vue-i18n'

export default /*#__PURE__*/_defineComponent({
  name: 'BallDetail',
  setup(__props, { expose }) {
  expose();

const { t } = useI18n()
const ConfigpiniaStore = serverConfigPiniaState();
const { offComments, commentAdUrl, commentAdImg } = storeToRefs(ConfigpiniaStore);

const { getConfig } = ConfigpiniaStore;

const zanIcon = require("@/assets/images/dianzan_icon.png");
const zanIconSel = require("@/assets/images/dianzan2_icon@3x.png");
const piniaStore = usePiniaState();
const { isYk } = storeToRefs(piniaStore);
const { toLogin } = piniaStore;

const route = useRoute();
const id = route.query.id
const data = ref()
const commentList = ref([])
//输入的文字
const inputValue = ref('');
onMounted(() => {
    getConfig()
    cheackQuery(route);
    getData()
    getCommentList()
    toLogin();
})

const getCommentList = async () => {
    const val: any = await ballNewsCommentList({ id })

    if (val.code == 200) {
        commentList.value = val.data.list
    }


}
const tozan = async (id, type, zanType) => {
    //type为1是赞文章，2是赞评论，  zanType 1是赞，0是取消点赞
    if (isYk.value) {
        nativeToLogin(router);
    }

    const res: any = await ballNewsZan({
        id, type, zan_type: zanType
    })

    if (res.code == 200) {
        if (type == 1) {
            getData()
        } else {
            getCommentList()
        }
    }
}

const scrollToAnchor = () => {
    let anchorElement = document.getElementById("activity1");
    if (anchorElement) {
        anchorElement.scrollIntoView({
            block: 'start',
            behavior: 'smooth'
        })
    }
}

const sendMsg = async () => {
    if (isYk.value) {
        nativeToLogin(router);
    }
    if (inputValue.value == "") {
        Toast.fail(t('me.qsrplnr'))
    }
    const res: any = await ballNewsComment({
        id,
        comment_id: 0,
        content: inputValue.value
    })
    if (res.code == 200) {
        inputValue.value = ""
        Toast.success(t('me.plcg'))
    }


}

const back = () => {
    ToBack(router)
    // router.back()
}
const getData = async () => {
    const val: any = await ballNewsDetail({ id })
    if (val.code == 200) {
        data.value = val.data
    }
}

const __returned__ = { t, ConfigpiniaStore, offComments, commentAdUrl, commentAdImg, getConfig, zanIcon, zanIconSel, piniaStore, isYk, toLogin, route, id, data, commentList, inputValue, getCommentList, tozan, scrollToAnchor, sendMsg, back, getData, sendBtn, toLocationBrowser }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})